import React, { useState, useEffect } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setOpinionStatus, setReferStatus } from "redux-helpers/ActionCreator";

import { isAdmin, isInstitutionAdmin, isPractitioner, isPatient } from "utils/UserHelper";
import { ProfileStatusConstants } from "utils/Constants";
import { FAILTOSAVERECOED } from "utils/Constants";
import { PractitionerService } from "utils/PractitionerService";

import PageNotFound from "pages/404";
import FeedHomePage from "pages/FeedHomePage";
import PatientHome from "pages/PatientHome/HomePage";
import SubscriptionPlans from "pages/SubscriptionPlans";
import Jobs from "pages/Jobs";
import Referals from "pages/Referals";
import { isOnlyApprovedAllowPathPractitioner } from "utils/Utils";
import Settings from "pages/Settings";
import PractitionerProfilesPage from "pages/FeedHomePage/components/PractitionerProfilesPage";
import JobHomePage from "pages/JobHomePage";
import FeedById from "pages/FeedByID";
import ApplyJobs from "pages/FeedHomePage/components/ApplyJobs";
import JobTracking from "pages/FeedHomePage/components/JobTracking";
import ApplicationDetails from "pages/FeedHomePage/components/JobTracking/Components/ApplicationDetails";
import CreateJobs from "pages/FeedHomePage/components/CreateJobs";
import CreateJobList from "common/NewJobScreen/CreateJobList";
import JobPreview from "pages/Jobs/Components/CreateJob/components/NewJobUi/NewForms/JobPreview";
import MyReferrals from "pages/Referals/Components/PatientDetails/Components/MyReferrals";
import Profile from "pages/Profile";
import AllConnectionsTab from "pages/Connections/components/AllConnections/components/AllConnectionsTab";
import Pending from "pages/Connections/components/Groups/components/Pending";
import Invitations from "pages/Connections/components/AllConnections/components/Invitations";
import MyPatients from "pages/Connections/components/MyPatients";
import GroupOwned from "pages/Connections/components/Groups/components/GroupOwned";
import GroupFollow from "pages/Connections/components/Groups/components/GroupFollow";
import GroupInvitation from "pages/Connections/components/Groups/components/GroupInvitation";
import GroupView from "pages/Connections/components/Groups/components/GroupView";
import PagesOwned from "pages/Connections/components/Pages/components/PagesOwned";
import pagesFollowed from "pages/Connections/components/Pages/components/pagesFollowed";
import Messages from "pages/Messages";
import PatientDetails from "pages/Referals/Components/PatientDetails";
import Institutions from "pages/Institutions";
import AllPractitionersWorkHereList from "pages/Institutions/components/InstitutionsDetails/components/PractitionersUI/AllPractitionersWorkHereList";
import InstitutionsAdmin from "pages/Institutions/components/InstitutionsAdmin";
import CreateInstitution from "pages/UIDashboard/CreateInstitution";
import CustomThemeDesign from "pages/UIDashboard/Components/CustomThemeDesign";
import UIDashboard from "pages/UIDashboard";
import StyleGuidline from "StyleGuidline";
import Reports from "pages/PatientProfile/Reports";
import Doctors from "pages/PatientProfile/Doctors";
import DoctorSingle from "pages/PatientProfile/DoctorSingle";
import Reviews from "pages/PatientProfile/Reviews";
import SecondOpinion from "pages/PatientProfile/SecondOpinion";
import MySecondOpinionLists from "pages/PatientProfile/SecondOpinion/components/MyOpinionsList";
import MedicalCases from "pages/PatientProfile/MedicalCases";
import ProfileDetails from "pages/PatientProfile/ProfileDetails";
import DemographicInfo from "pages/PatientProfile/DemographicInfo";
import InsuranceSettings from "pages/PatientProfile/InsuranceSettings";
import SecondOpinionForm from "pages/PatientProfile/SecondOpinion/components";
import UserView from "pages/PatientProfile/UserView";
import UserSearchView from "pages/PatientProfile/UserView/UserSearchView";
import NoAppointments from "pages/PatientProfile/NoAppointments";
import Notifications from "pages/PatientProfile/Notifications";
import EmailPreview from "pages/PatientProfile/SecondOpinion/components/EmailPreview";
import Invoice from "pages/PatientProfile/Invoice";
import OpinionDetailsPage from "pages/PatientProfile/SecondOpinion/components/OpinionDetailsPage";
import OpinionResponsePage from "pages/PatientProfile/SecondOpinion/components/OpinionResponsePage";
import ReceivedSecondOpinionLists from "pages/PatientProfile/SecondOpinion/components/ReceivedOpinionLists";
import ReceivedOpinionResponse from "pages/PatientProfile/SecondOpinion/components/ReceivedOpinionResponse";
import SecondOpinionCreationNew from "pages/PatientProfile/SecondOpinion/components/SecondOpinionCreationNew";
import ReceivedOpinionDetailsPage from "pages/PatientProfile/SecondOpinion/components/ReceivedOpinionDetailsPage";
import MyOpinionResponsePage from "pages/PatientProfile/SecondOpinion/components/MyOpinionResponsePage";
import MyOpinionDetailPage from "pages/PatientProfile/SecondOpinion/components/MyOpinionDetailPage";
import ConsultlationAdd from "pages/PatientProfile/SecondOpinion/components/Consultlation";
import ConsultlationView from "pages/PatientProfile/SecondOpinion/components/Consultlation/view";
import AppointmentLists from "pages/PatientProfile/Appointments/AppointmentLists";
import AppointmentUpcomming from "pages/PatientProfile/Appointments/AppointmentUpcomming";
import AppointmentDetails from "pages/PatientProfile/Appointments/AppointmentDetails";
import AppointmentAdd from "pages/PatientProfile/Appointments/AppointmentAdd";
import WeekCalender from "pages/PatientProfile/Appointments/Doctor/WeekCalender";
import DayCalender from "pages/PatientProfile/Appointments/Doctor/DayCalender";
import AdsTemplates from "pages/Ads/AdsTemplates";
import AdsOne from "pages/Ads/AdsOne";
import AdsTwo from "pages/Ads/AdsTwo";
import AdsThree from "pages/Ads/AdsThree";
import AdsFour from "pages/Ads/AdsFour";
import AdsFive from "pages/Ads/AdsFive";
import AdsSix from "pages/Ads/AdsSix";
import AdsSeven from "pages/Ads/AdsSeven";
import AdsEight from "pages/Ads/AdsEight";
import AdsNine from "pages/Ads/AdsNine";
import AdsTen from "pages/Ads/AdsTen";
import AdsEleven from "pages/Ads/AdsEleven";
import AdsTwelve from "pages/Ads/AdsTwelve";
import Appointments from "pages/PatientProfile/Appointments";
import AppointmentsCalendar from "pages/AppointmentsCalendar";

const Content = () => {
  const dispatch = useDispatch();

  const currentUser = useSelector((state) => state.auth.currentUser);
  const referalStatusFlag = useSelector((state) => state.PreferenceFlags?.referalStatusFlag);
  const opinionStatusFlag = useSelector((state) => state.PreferenceFlags?.opinionStatusFlag);

  const [state, setState] = useState({
    message: "",
    channel: "",
    timeToken: "",
    activeFlag: false,
    redirectToNotFound: false,
  });

  const getRecentMessage = (message, channel, timeToken) => {
    if (message && message.length > 0) {
      setState((prevState) => ({
        ...prevState,
        message: message,
        channel: channel,
        timeToken: timeToken,
      }));
    }
  };

  const getPractitionerReferFlag = async (guid) => {
    try {
      const response = await PractitionerService.getPreferences(guid);
      const { status, data } = response;

      if (status === 200) {
        dispatch(setReferStatus(data?.openForReferral));
        dispatch(setOpinionStatus(data?.availableForSecondOpinion));
      } else {
        console.error(FAILTOSAVERECOED);
      }
    } catch (error) {
      console.error("Error fetching preferences:", error);
    }
  };

  useEffect(() => {
    if (isPractitioner() && currentUser?.guid) {
      getPractitionerReferFlag(currentUser?.guid);
    }

    const timeout = setTimeout(() => {
      setState((prevState) => ({ ...prevState, redirectToNotFound: true }));
    }, 2000);

    return () => clearTimeout(timeout); 
  }, [currentUser]);

  const isAdminUser = isAdmin();
  const isInstitutionAdminUser = isInstitutionAdmin();
  const isPractitionerUser = isPractitioner();
  const isPatientUser = isPatient();

  return (
    <>
      <Switch>
        {/* HOME -----*/}
        <Route path={isOnlyApprovedAllowPathPractitioner((isPractitionerUser && currentUser?.status === ProfileStatusConstants.APPROVED) || isInstitutionAdminUser || isAdminUser, "/home")}>
          {isPatientUser ? (<PatientHome />) : (<FeedHomePage message={state.message} channel={state.channel} timeToken={state.timeToken} />)}
        </Route>
        <Route exact path={["/", "/home"]} render={() => isPractitionerUser && currentUser?.status !== ProfileStatusConstants.APPROVED ? (<Redirect to={`/profile/${currentUser?.profileId}/`} />) : isPatientUser ? (<PatientHome />) : (<FeedHomePage message={state.message} channel={state.channel} timeToken={state.timeToken} />)} />
        {(isPractitionerUser && currentUser?.status === ProfileStatusConstants.APPROVED) && (
          <Route exact path="/subscriptions/upgrade" component={SubscriptionPlans} />
        )}

        {/* Dashboard */}
          {/* {process.env.REACT_APP_HIDE_STATIC_CONTENT === "false" && (
            <Route path="/dashboard" component={Dashboard} />
          )} */}

        {/* MESSAGES ROUTES ----*/}
        {(currentUser.status === ProfileStatusConstants.APPROVED ||
          !isAdminUser || isInstitutionAdminUser || isPractitionerUser) && (
            <Route path="/messages">
              <Messages getRecentMessage={getRecentMessage} />
            </Route>
          )}

        {/* NETWORK ROUTES -----*/}
        <Route exact path="/networks/connections/active" component={AllConnectionsTab} />
        <Route exact path="/networks/connections/pending" component={Pending} />
        <Route exact path="/networks/connections/invitations" component={Invitations} />
        <Route exact path="/networks/my-patients" component={MyPatients} />
        <Route exact path="/networks/groups/owned" component={GroupOwned} />
        <Route exact path="/networks/groups/followed" component={GroupFollow} />
        <Route exact path="/networks/groups/invitations" component={GroupInvitation} />
        <Route exact path="/connections/groups/:id" component={GroupView} />
        <Route exact path="/networks/pages/owned" component={PagesOwned} />
        <Route exact path="/networks/pages/followed" component={pagesFollowed} />

        {/* JOBS ROUTES -----*/}
        <Route path="/jobs/:jobId" component={JobHomePage} />
        <Route path={"/apply-jobs"} component={ApplyJobs} />
        <Route path={"/job-tracking/:jobId"} component={JobTracking} />
        <Route path={"/application-details/:jobApplicationId"} component={ApplicationDetails} />
        {process.env.REACT_APP_HIDE_STATIC_CONTENT === "false" && (
          <Route path={"/create-jobs"} component={CreateJobs} />
        )}
        {(currentUser.status === ProfileStatusConstants.APPROVED || isAdminUser || isInstitutionAdminUser) ? <Route path="/jobsboard" component={Jobs} /> : ''}
        <Route path={"/new/create-jobs"} component={CreateJobList} />
        <Route path={"/new/update-jobs/:jobId"} component={CreateJobList} />
        <Route path={"/new/job-preview/:jobId"} component={JobPreview} />

        {/* REFERRAL------ */}
        {((isPractitionerUser && currentUser.status === ProfileStatusConstants.APPROVED && referalStatusFlag) || isPatientUser) &&
          <Route path={"/referrals"} component={Referals} />
        }

        {/* PRACTITIONER ROUTE ------*/}
        {!isPatientUser &&
          <Route path="/profiles" component={PractitionerProfilesPage} />
        }
        <Route exact path="/profile/:profileId/" component={Profile} />

        {/* Settings -----*/}
        {!isAdminUser && <Route path="/settings" component={Settings} />}

        {/* FEEDS-----*/}
        {process.env.REACT_APP_HIDE_STATIC_CONTENT === "false" &&
            !isAdminUser && (
              <Route path="/practitioner-service/practitioners/:pid/feeds/:id" component={FeedById}/>
            )}
          {/* Appointments */}
          {currentUser.status === ProfileStatusConstants.APPROVED &&
            !isAdminUser && (
              <Route path="/appointments" component={AppointmentsCalendar} />
            )}

        {/* INSTITUTIONS ROUTES ------*/}
        <Route exact path="/institution/:institutionID" component={Institutions} />
        <Route exact path="/institution/:institutionID/view-all-practitioners" component={AllPractitionersWorkHereList} />
        {/* institution admin page  */}
        {(isAdminUser || isInstitutionAdminUser) &&
          <Route exact path="/u/institution/:institutionID/admin" component={InstitutionsAdmin} />
        }

        {/* MICROSITE MODULE ROUTES */}
        <Route path={"/ui-dashboard"}>{isAdminUser ? <UIDashboard /> : ""}</Route>
        <Route path={"/create-webpage"}>{isAdminUser || isInstitutionAdminUser ? <CreateInstitution /> : ""}</Route>
        {/* {isAdminUser && <Route exact path="/microsite/create-template/:id" component={ThemeDesign2} />} */}
        {isAdminUser || isInstitutionAdminUser ? <Route exact path="/microsite/custom-theme" component={CustomThemeDesign} /> : ''}

        {/* PATIENT ROUTES------*/}
        {/* {isPatientUser && <Route exact path="/my-referrals" component={MyReferrals} />} */}
        <Route exact path="/patient-profile/:patientId" component={PatientDetails} />
        <Route path={"/patient-home"} component={PatientHome} />
        {isPatientUser && (
          <>
            <Route exact path="/my-referrals" component={MyReferrals} />
            <Route exact path="/u/appointments" component={Appointments} />
            <Route exact path="/u/reports" component={Reports} />
            <Route exact path="/u/doctors" component={Doctors} />
            <Route exact path="/u/doctor" component={DoctorSingle} />
            <Route exact path="/u/doctor/reviews" component={Reviews} />
            <Route exact path="/u/medicalcases" component={SecondOpinion} />
            {/* <Route exact path="/u/medicalcases" component={MedicalCases} /> */}
            <Route exact path="/u/profile/:firstName-:id" component={ProfileDetails} />
            <Route exact path="/u/profile/:firstName-:id/demographic-info" component={DemographicInfo} />
            <Route exact path="/u/profile/:firstName-:id/insurance" component={InsuranceSettings} />
            <Route exact path="/u/medicalcases/edit-my-second-opinion/:opinionId" component={SecondOpinionForm} />
            <Route exact path="/u/user-view" component={UserView} />
            <Route exact path="/u/user-search-view" component={UserSearchView} />
            <Route exact path="/u/medical-records" component={UserSearchView} />
            <Route exact path="/u/no-appointments" component={NoAppointments} />
            <Route exact path="/u/profile/:firstName-:id/notification" component={Notifications} />
            <Route exact path="/u/medicalcases/email-preview" component={EmailPreview} />
            <Route exact path="/u/invoice" component={Invoice} />
          </>
        )}
        {(isPatientUser || isPractitionerUser) && <Route exact path="/u/medicalcases/create-new-second-opinion" component={SecondOpinionForm} />}

        {/* SECOND OPINION ROUTES ---*/}
        <Route exact path="/u/medicalcases/opinions/:opinionId" component={OpinionDetailsPage} />
        <Route exact path="/u/medicalcases/opinions/:opinionId/response" component={OpinionResponsePage} />
        {isPractitionerUser && currentUser.status === ProfileStatusConstants.APPROVED && opinionStatusFlag &&
          <>
            <Route exact path="/u/medicalcases/received-opinions" component={ReceivedSecondOpinionLists} />
            <Route exact path="/u/medicalcases/received-opinions/:opinionId/response" component={ReceivedOpinionResponse} />
          </>
        }
        { /* second opinion HTMLs Routes  */}
        {/* <Route exact path="/u/medicalcases/second-opinions/html" component={SOHtml} /> */}
        <Route exact path="/u/medicalcases/second-opinion/create" component={SecondOpinionCreationNew} />
        <Route exact path="/u/medicalcases/second-opinion/update/:opinionId" component={SecondOpinionCreationNew} />
        {/* <Route exact path="/u/medicalcases/sent-opinions" component={SentSecondOpinionLists} />
          <Route exact path="/u/medicalcases/sent-opinions/:opinionId/response" component={OpinionResponse} /> */}
        <Route exact path="/u/medicalcases/received-opinions/:opinionId" component={ReceivedOpinionDetailsPage} />
        {/* <Route exact path="/u/medicalcases/sent-opinions/:opinionId" component={ViewDetails} /> */}
        <Route exact path="/u/medicalcases/my-opinions" component={MySecondOpinionLists} />
        <Route exact path="/u/medicalcases/my-opinions/:opinionId" component={MyOpinionDetailPage} />
        <Route exact path="/u/medicalcases/my-opinions/:opinionId/response" component={MyOpinionResponsePage} />
        <Route exact path="/u/medicalcases/details/consultlation/add" component={ConsultlationAdd} />
        <Route exact path="/u/medicalcases/details/consultlation/" component={ConsultlationView} />

        {/** APPOINTMENT ROUTES--- */}
        <Route exact path="/u/appointments/list" component={AppointmentLists} />
        <Route exact path="/u/appointments/upcoming" component={AppointmentUpcomming} />
        <Route exact path="/u/appointments/details" component={AppointmentDetails} />
        <Route exact path="/u/appointments/add" component={AppointmentAdd} />
        <Route exact path="/u/appointments/doctor/week-calender" component={WeekCalender} />
        <Route exact path="/u/appointments/doctor/day-calender" component={DayCalender} />        

        {/* MISCELANEOUS & REFERENCES------- */}
        <Route path={"/style-guidlines"} component={StyleGuidline} />
        {/* Ads ---*/}
        <Route exact path="/u/ads-templates" component={AdsTemplates} />
        <Route exact path="/u/ads-one" component={AdsOne} />
        <Route exact path="/u/ads-two" component={AdsTwo} />
        <Route exact path="/u/ads-three" component={AdsThree} />
        <Route exact path="/u/ads-four" component={AdsFour} />
        <Route exact path="/u/ads-five" component={AdsFive} />
        <Route exact path="/u/ads-six" component={AdsSix} />
        <Route exact path="/u/ads-seven" component={AdsSeven} />
        <Route exact path="/u/ads-eight" component={AdsEight} />
        <Route exact path="/u/ads-nine" component={AdsNine} />
        <Route exact path="/u/ads-ten" component={AdsTen} />
        <Route exact path="/u/ads-eleven" component={AdsEleven} />
        <Route exact path="/u/ads-twelve" component={AdsTwelve} />

        {/* Redirect to Not Found */}
        {state.redirectToNotFound && <Route component={PageNotFound} />}
      </Switch>
    </>
  );
};

export default Content;